import axios from 'axios';

const getToken = (soDienThoai, matKhau) => {
    return axios
        .post(process.env.REACT_APP_URL_SERVER + '/cus/login', {
            soDienThoai: soDienThoai,
            matKhau: matKhau
        })
        .then((response) => {
            if (response.data) {
                axios.defaults.headers.common['Authorization'] = response.data.access_token;
                document.cookie = 'tk=' + response.data.access_token + '; path=/';
            }
            return response.data;
        });
};
function kiemTraDoiMatKhau(soDienThoai, matKhau) {
    return axios.post(process.env.REACT_APP_URL_SERVER + '/cus/login', {
        soDienThoai: soDienThoai,
        matKhau: matKhau
    });
}
const dangNhapService = {
    getToken,
    kiemTraDoiMatKhau
};
export default dangNhapService;
